<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_documents'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-show="userData.permissions['add_documents'] == 1" v-b-modal.new-document-type size="sm"
                variant="primary"><i class="mdi mdi-plus"></i> New Document Type</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy" show-empty>
                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow"
                      small></b-spinner> <strong>Fetching data...</strong></div>
                </template>
                <template #empty>
                  <div class="text-center p-5 bg-light rounded border border-dashed">

                    <div class="text-muted mb-3">
                      <i class="display-4 mdi mdi-folder-open-outline"></i>
                    </div>

                    <h5 class="fw-bold text-dark mb-2">No Document Types Yet</h5>

                    <p class="text-muted mb-4 max-w-sm mx-auto">
                      Document Types help you organize and categorize your documents efficiently. Create your first one
                      to get started.
                    </p>

                    <b-button v-show="userData.permissions['add_documents'] == 1" v-b-modal.new-document-type
                      variant="primary">
                      <i class="mdi mdi-plus me-1"></i> Add Document Type
                    </b-button>

                  </div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(name)="data">
                  {{ data.item.name }}
                  <small class="d-block text-muted"><i>{{ data.item.description }}</i> </small>
                </template>
                <template #cell(documents)="data">
                  <span v-if="data.item.documents > 0" class="fw-medium">
                    {{ data.item.documents }} document<span v-if="data.item.documents != 1">s</span>
                  </span>

                  <b-badge v-else class="text-muted border px-2" :class="{}">
                    None
                  </b-badge>
                </template> <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button v-show="userData.permissions['add_documents'] == 1"
                      @click="edit(data.item.id, data.item.name, data.item.description)" type="button"
                      class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i>
                    </b-button>
                    <b-button v-show="userData.permissions['delete_documents'] == 1"
                      @click="remove(data.item.id, data.item.name)" type="button" class="btn-sm btn" variant="danger"
                      v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Company Documents</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-document-type" centered title="New Document Type" title-class="font-18" hide-footer>
      <form @submit.prevent="addDocumentType">
        <div class="form-group mb-4">
          <label class="mb-0">Name <span class="text-danger">*</span></label>
          <input v-model="name" type="text" class="form-control" placeholder="e.g Financial Reports" />
        </div>
        <div class="form-group mb-2">
          <label class="mb-0 fw-medium">
            Description <span class="text-muted fw-normal fst-italic">(optional)</span>
          </label> <textarea v-model="description" class="form-control"
            placeholder="e.g A detailed report of the company's financial performance"></textarea>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('new-document-type')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary">
            <b-spinner small v-if="loading"></b-spinner>
            <span v-else><i class="fas fa-check-circle"></i>
              Submit</span>
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="edit-document-type" centered title="Edit Document Type" title-class="font-14" hide-footer>
      <form @submit.prevent="editDocumentType">
        <div class="form-group mb-4">
          <input v-model="id" type="hidden">
          <label class="mb-0">Name</label>
          <input v-model="name" type="text" class="form-control" />
        </div>
        <div class="form-group mb-2">
          <input v-model="id" type="hidden">
          <label class="mb-0">Description</label>
          <textarea v-model="description" type="text" class="form-control"></textarea>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('edit-document-type')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary">
            <b-spinner small v-if="loading"></b-spinner>
            <span v-else><i class="fas fa-check-circle"></i> Submit</span>
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-document-type" centered title="Delete Document Type" title-class="font-18" hide-footer>
      <form @submit.prevent="deleteDocumentType">
        <input v-model="id" type="hidden">

        <div class="text-center mb-4 mt-2">
          <i class="mdi mdi-alert-circle-outline display-4 text-danger d-block mb-2"></i>
          <p class="mb-1 fs-5">
            Are you sure you want to delete the Document Type:<br>
            <strong class="text-dark">{{ name }}</strong>?
          </p>
          <small class="text-muted">This action cannot be undone.</small>
        </div>

        <div class="d-flex justify-content-center mt-4">
          <b-button type="button" class="btn px-4" variant="light" @click="$bvModal.hide('delete-document-type')">
            Cancel
          </b-button>

          <b-button type="submit" class="btn ms-2 px-4" variant="danger">
            <i class="mdi mdi-delete-outline me-1"></i> Delete
          </b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
// import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { documentTypeMethods, documentTypeComputed } from "@/state/helpers";

export default {
  page: {
    title: "Document Types",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Document Types",
      items: [{ text: "Dashboard", to: "/", }, { text: "Document Types", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        { key: 'name', label: 'Name', visible: true },
        { key: 'documents', label: 'Documents', visible: true },
        { key: 'created_at', label: 'Added on', visible: true },
        { key: 'actions', label: 'Actions', visible: true },
      ],
      id: '',
      name: '',
      description: '',
      loading: false,
    };
  },
  computed: {
    ...documentTypeComputed,
    List() { return (this.documenttypes || []).length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return (this.documenttypes || []).map((d) => ({ ...d })) },
    IsBusy() { return this.loadingDocumentTypes; },
  },
  mounted() {
    this.fetchDocumentTypes();
    this.TotalRows = (this.documenttypes || []).length;
  },
  methods: {
    ...documentTypeMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, name, description) {
      this.id = id;
      this.name = name;
      this.description = description;
      this.$bvModal.show('edit-document-type')
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show('delete-document-type')
    },
    async addDocumentType() {
      this.loading = true;
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("description", this.description);
      let url = "/create-document-type";
      axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchDocumentTypes();
          this.$bvModal.hide('new-document-type');
          this.name = "";
          this.description = "";
          this.loading = false;
          this.$toast.success("New Document Type Added");
        } else {
          this.loading = false;
          this.$toast.error(response?.data?.message || response?.data?.error || "An error occurred");
        }
      }).catch((error) => {
        this.loading = false;
        this.$toast.error(error?.response?.data?.message || error?.response?.data?.error || "An error occurred");
      });
    },
    async editDocumentType() {
      this.loading = true;
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("description", this.description);
      let url = "/update-document-type";
      axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchDocumentTypes();
          this.$bvModal.hide('edit-document-type');
          this.name = "";
          this.description = "";
          this.loading = false;
          this.$toast.success("Document Type Updated");
        } else {
          this.loading = false;
          this.$toast.error(response?.data?.message || response?.data?.error || "An error occurred");
        }
      }).catch((error) => {
        this.loading = false;
        this.$toast.error(error?.response?.data?.message || error?.response?.data?.error || "An error occurred");
      });
    },
    async deleteDocumentType() {
      this.loading = true;
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/delete-document-type";
      axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchDocumentTypes();
          this.$bvModal.hide('delete-document-type');
          this.$toast.success("Document Type Deleted");
          this.name = "";
          this.loading = false;
        } else {
          this.loading = false;
          this.$toast.error(response?.data?.message || response?.data?.error || "An error occurred");
        }
      }).catch((error) => {
        this.loading = false;
        if (error?.response?.status === 400) {
          this.$toast.error("Cannot delete a document type that has documents attached to it.");
        } else {
          this.$toast.error(error?.response?.data?.message || error?.response?.data?.error || "An error occurred");
        }
      });
    },
  },
};
</script>